import '@babel/polyfill';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import VJstree from 'vue-jstree';
import AsyncComputed from 'vue-async-computed';

import VueResource from 'vue-resource';
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

import VTooltip from 'v-tooltip';

import App from './App.vue';

import router from './router';
import store from './store';

import 'vue-material-design-icons/styles.css';

Vue.config.productionTip = false;

Vue.use(VJstree);
Vue.use(VueResource);
Vue.use(Loading);
Vue.use(VTooltip);
Vue.use(AsyncComputed);

Vue.http.options = {
  root: '/symdb',
  responseType: 'json',
  emulateJSON: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    Accept: 'application/json',
  },
};

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
